import React from 'react'
import { Container, Row } from "react-bootstrap";

export default function ServicesList({ title1, title2 }) {
  return (
    <Container fluid>
      <Row className='titleRow justify-content-center my-4'>
        <div className="py-md-0 pl-1 servicesTitle ">
          <h1>{title1}</h1>
          <h5 className="serviceTitle1">{title2}</h5>
        </div>
      </Row>
    </Container>

  )
}
